// <copyright file="api-url-configuration.service.ts" company="BD">
// Copyright (c) BD. All rights reserved.
// </copyright>

import { Injectable } from "@angular/core";

/**
 * Service that provides the API endpoint based on the browser URL.
 * Enables a single build to work across dev, fvnv, and production environments.
 *
 * URL Mapping:
 * dev-msu.bd.com → dev-webapi-msu.bd.com
 * fvnv-msu.bd.com → fvnv-webapi-msu.bd.com
 * msu.bd.com → webapi-msu.bd.com
 */
@Injectable({
  providedIn: "root"
})
export class ApiUrlConfigurationService {
  private readonly apiEndpoint: string;

  constructor() {
    this.apiEndpoint = this.resolveEndpoint(this.getOrigin());
  }

  protected getOrigin(): string {
    return window.location.origin;
  }

  resolveEndpoint(origin: string): string {
    if (origin.includes("localhost")) {
      return "https://dev-webapi-msu.bd.com";
    }

    // For all environments: replace msu.bd.com with webapi-msu.bd.com
    // dev-msu.bd.com → dev-webapi-msu.bd.com
    // fvnv-msu.bd.com → fvnv-webapi-msu.bd.com
    // msu.bd.com → webapi-msu.bd.com
    if (origin.includes("msu.bd.com")) {
      return origin.replace("msu.bd.com", "webapi-msu.bd.com");
    }

    throw new Error(`Unsupported origin: ${origin}. Expected localhost or *msu.bd.com`);
  }

  getApiEndpoint(): string {
    return this.apiEndpoint;
  }
}
